var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"teacher-item",attrs:{"to":{
    name: 'ShowTeachersDetaial',
    params: { id: _vm.data.teacher_id },
    query: { route_name: 'ShowTeachers', route_label: '名师' },
  }}},[_c('div',{staticClass:"wrap"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.data.teacher_avatar}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.data.teacher_name))]),_c('div',{staticClass:"introduction"},[_vm._v(_vm._s(_vm.data.introduction))]),(
        _vm.data.level_name && _vm.$store.state.commonSetting.switch_oto_module == 1
      )?_c('div',{staticClass:"tag"},[_vm._v("\n      约课\n    ")]):_vm._e(),_c('div',{staticClass:"arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }